<template>
  <vx-card class="mb-4" title="Тарифы в каталоге ГИС ЖКХ">
    <template slot="actions">
      <div :class="$style.catalogInfo">
        Файл каталога:
        <ellipsis-component v-if="actualCatalog" :class="$style.catalogInfoName" position="middle">{{
            actualCatalog.name
          }}
        </ellipsis-component>
        <span v-else>-</span>
        <div v-if="actualCatalog" :class="$style.catalogInfoDate">
          Загружен {{ formatDate(actualCatalog.created_at) }}
        </div>
      </div>
      <vs-button type="border" @click="onUpload">Обновить каталог</vs-button>
    </template>

    <vs-tabs :key="selectedHouseId" ref="tabs">
      <vs-tab v-for="type in availableTypes" :key="type.id" :label="type.name">
        <table v-if="tariffs" :class="$style.table">
          <thead>
          <tr>
            <th>Название</th>
            <th colspan="3">В каталоге ГИС ЖКХ</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="tariffsGroup in tariffs[type.id]">
            <tr :key="tariffsGroup.id" :class="$style.group">
              <td colspan="4">{{ tariffsGroup.title }}</td>
            </tr>
            <tr v-for="tariff in tariffsGroup.tariffs" :key="tariff.id">
              <td :class="$style.tariffTitle">
                {{ tariff.name }}
                <app-icon v-if="!tariff.gis_utility_id" :class="$style.emptyAlert" name="AlertRoundIcon" size="20px" />
              </td>
              <template v-if="tariff.gis_utility_id">
                <td>{{ gisTariffsDict[tariff.gis_utility_id].groupName }}</td>
                <td>{{ gisTariffsDict[tariff.gis_utility_id].name }}</td>
              </template>
              <td v-else :class="$style.empty" colspan="2">Не выбрано</td>
              <td :class="$style.actions">
                <vs-button
                  size="small"
                  type="border"
                  iconPack="feather"
                  icon="icon-edit"
                  title="Изменить"
                  @click="onEdit(tariff)"
                />
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </vs-tab>
    </vs-tabs>
  </vx-card>
</template>

<script>
import formatDate            from "@/client/helpers/formatDate";
import { ellipsisComponent } from '@hyjiacan/vue-ellipsis';

export default {
  name:       "gisTariffs",
  components: { ellipsisComponent },
  data() {
    return {
      tabIndex:       0,
      tariffs:        null,
      gisTariffs:     null,
      gisTariffsDict: null,
      actualCatalog:  null,
    };
  },

  computed: {
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },

    apartmentsTypes() {
      return this.$store.getters['appUser/apartmentsTypes'];
    },

    availableTypes() {
      let typesIds = this.$store.getters['appUser/selectedHouse'].available_types;
      if (!typesIds) return [];
      return typesIds
        .split(',')
        .map(typeId => this.apartmentsTypes.find(type => type.id === +typeId));
    },
  },

  methods: {
    formatDate,

    onEdit( tariff ) {
      this.$modal.open({
        size:           'md',
        title:          'Выбрать соответствующий тариф из каталога',
        component:      () => import('@/components/employee/gis/gisTariffSelectPopup'),
        componentProps: {
          tariff,
          gisTariffs: this.gisTariffs,
          onSubmit:   ( gisTariffId ) => {
            return this.$http({
              method: 'POST',
              url:    'gis/utilities/settings',
              params: { buildings_id: tariff.buildings_id },
              data:   [{
                "tariff_id":      tariff.id,
                "gis_utility_id": gisTariffId,
              }],
            }).then(() => this.loadData());
          },
        },
      });
    },

    onUpload() {
      this.$modal.open({
        size:           'sm',
        title:          'Загрузить файл',
        component:      () => import('@/components/employee/gis/gisTariffUploadPopup'),
        componentProps: {
          onSubmit: ( file ) => {
            let body = new FormData();
            body.append('file', file);
            return this.$http({
              method: 'POST',
              url:    'gis/utilities/import',
              params: { buildings_id: this.selectedHouseId },
              data:   body,
            }).then(() => this.loadData());
          },
        },
      });
    },

    loadTariffs() {
      return Promise.all([
        this.$http.get('tarifs', { params: { buildings_id: this.selectedHouseId } }),
        this.$http.get('/gis/utilities', { params: { buildings_id: this.selectedHouseId } }),
      ]).then(( [{ data: tariffs }, { data: gisTariffs }] ) => {
        const typesDict = {};

        tariffs.forEach(( tariff ) => {
          const group = tariff.tarifs_group;
          if (!group) return;
          const type = tariff.apartments_type;

          if (!typesDict[type]) typesDict[type] = {};
          if (!typesDict[type][group.id]) typesDict[type][group.id] = {
            id:       group.id,
            title:    group.name,
            position: group.position,
            tariffs:  [],
          };
          typesDict[type][group.id].tariffs.push(tariff);
        });

        const sortByPosition = ( i1, i2 ) => i1.position === i2.position ? 0 : i1.position > i2.position ? 1 : -1;
        for (let typeId in typesDict) {
          typesDict[typeId] = Object.values(typesDict[typeId]).sort(sortByPosition);

          typesDict[typeId].forEach(tariffsGroup => {
            tariffsGroup.tariffs.sort(sortByPosition);
          });
        }
        this.tariffs = typesDict;

        this.gisTariffsDict = gisTariffs.reduce(( dict, gisTariffsGroup ) => {
          gisTariffsGroup.items.forEach(gisTariff => dict[gisTariff.id] = {
            groupName: gisTariffsGroup.group,
            name:      gisTariff.name,
          });
          return dict;
        }, {});
        this.gisTariffs = gisTariffs;
      });
    },

    loadCatalogInfo() {
      this.$http.get('gis/utilities/template', { params: { buildings_id: this.selectedHouseId } }).then(( { data } ) => {
        this.actualCatalog = data;
      });
    },

    loadData() {
      this.loadTariffs();
      this.loadCatalogInfo();
    },
  },

  mounted() {
    this.loadData();
  },

  watch: {
    selectedHouseId() {
      this.tabIndex = 0;
      this.loadData();
    },
  },
};
</script>

<style lang="scss" module>
$border: 1px solid #d2d2d2;
.table {
  border-collapse: collapse;
  width: 100%;

  tbody {

    td {
      border-bottom: $border;
      padding: 7px 10px;

      &.actions {
        width: 1%;
        padding: 0 10px;
      }
    }

    td:last-child {
      border-right: $border;
    }

    td:first-child {
      border-left: $border;
    }
  }
}

.group td {
  background: #f2f2f2;
  border-top: $border;
  border-bottom: $border;
  font-weight: 500;
}

.tariffTitle {
  border-right: $border;
}

.empty {
  opacity: .3;
  font-style: italic;
}

.emptyAlert {
  margin-left: 5px;
  color: color(danger);
  vertical-align: middle;
}

.catalogInfo {
  margin-right: 1em;
  flex-shrink: 0;
}

.catalogInfoName {
  display: inline-block;
  max-width: 200px;
}

.catalogInfoDate {
  font-size: .85em;
  opacity: .5;
}
</style>
